<div
    class="d-flex align-items-center"
    [attr.data-cy]="'subform-' + sectionLayoutDefinitionName"
>
    @if (!CUSTOM_SUMMARY_TYPES.includes($any(titleField?.fieldType))) {
        @if (
            titleValue && titleField?.selectSource === SELECT_API_SOURCE.Country
        ) {
            <div
                class="icon-container d-flex justify-content-center align-items-center rounded-circle bg-icon icon-container-size-md"
            >
                <span class="flag flag-{{ titleValue | lowercase }}"></span>
            </div>
        } @else {
            <wdx-icon
                class="bg-icon icon-container d-flex justify-content-center align-items-center rounded-circle bg-icon icon-container-size-md"
                icon="arrow-alt-right"
            >
            </wdx-icon>
        }
    }
    <div #avatarTarget></div>
    <ng-template wdxFFSubformControlHost></ng-template>
    @if (avatarDefaultIcon) {
        <ng-container *ngTemplateOutlet="defaultIcon"></ng-container>
    }

    <div class="d-block position-relative flex-grow-1 px-2">
        <div
            class="h6"
            data-cy="subform-info-title"
            [innerHtml]="title$ | ngrxPush | booleanToYesNo"
        ></div>
        <div class="d-flex align-items-center">
            @if (subtitles$ | ngrxPush; as subtitles) {
                @for (subtitle of subtitles; track $index; let last = $last) {
                    <div
                        class="small divider--short"
                        [class.divider-end]="!last"
                    >
                        {{ subtitle | translateTokenisedString }}
                    </div>
                }
            }
            @if (isPrimaryField) {
                <div class="ms-1">
                    <wdx-badge class="small text-truncate" themeColor="primary">
                        {{ 'FORM_LABEL_PRIMARY' | translateTokenisedString }}
                    </wdx-badge>
                </div>
            }
            @for (badge of badges; track $index) {
                <div class="ms-1">
                    <wdx-badge
                        class="small text-truncate"
                        [themeColor]="$any(badge.colour)"
                    >
                        {{ badge.label | translateTokenisedString }}
                    </wdx-badge>
                </div>
            }
        </div>
    </div>
</div>

<ng-template #defaultIcon>
    <wdx-icon
        class="bg-icon icon-container d-flex justify-content-center align-items-center rounded-circle bg-icon icon-container-size-md"
        icon="arrow-alt-right"
    >
    </wdx-icon>
</ng-template>
